import React from "react";
import EmployeeScheduleTemplateForm from "./components/EmployeeScheduleTemplateForm";
import { useParams } from "react-router-dom";

const ViewEmployeeScheduleTemplate = () => { 
    const { templateId } = useParams();
    
    return (
        <div className="">
          <EmployeeScheduleTemplateForm mode="view" recordId={templateId}/>
        </div>
    );
};

export default (ViewEmployeeScheduleTemplate);